import type { FileUploadResult } from '@types'
import { uploadFile, uploadFiles } from './base'

export const fileService = {
  /**
   * Upload a single file
   * @param file - File or Blob to upload
   * @param options.keepName - Keep the original filename (requires authentication)
   */
  async upload(
    file: File | Blob,
    options: { keepName?: boolean } = {}
  ): Promise<FileUploadResult> {
    return uploadFile('/files', file, options)
  },

  /**
   * Upload multiple files at once
   * @param files - Array of Files or Blobs to upload
   */
  async uploadBulk(files: (File | Blob)[]): Promise<FileUploadResult[]> {
    return uploadFiles('/files/bulk', files)
  },
}
